import { dataFileShareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileShareSolid = /*#__PURE__*/createIcon(dataFileShareSolid)
export default IconFileShareSolid
